// extracted by mini-css-extract-plugin
export var fadeInOut = "_3y-3";
export var icon = "_3y-4";
export var savedIndicator = "_3y-2";
export var savingIndicator = "_3y-0";
export var spin = "_3y-1";